/**
 * Condition-key display policy for the site Alarms tab.
 *
 * Generator and BMS drivers emit readable dotted keys (`gen.dtc.code`), which
 * are genuinely useful to an operator cross-referencing a point map. Some BMS
 * bit-level conditions instead carry a bare UUID (`070d0bb2-56f5-…`), which is
 * pure noise on a list row. Opaque keys are suppressed on the row and remain
 * visible in the slide-over's "Condition key" field, so nothing is lost.
 */

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isOpaqueConditionKey(key: string): boolean {
  return UUID_RE.test(key.trim());
}

/** The key when it is worth showing on a row, otherwise undefined. */
export function conditionKeyLabel(key: string): string | undefined {
  return isOpaqueConditionKey(key) ? undefined : key;
}
